"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BREADCRUMBS = 'BREADCRUMBS';
exports.NOTIFICATION_SEND = 'NOTIFICATION_SEND';
exports.NOTIFICATION_DISMISS = 'NOTIFICATION_DISMISS';
exports.NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/utils/constants.js
// module id = 888
// module chunks = 0